module.exports = __webpack_public_path__ + "img/iso.df257b58.svg";